import React from 'react';
import UserDropdown from '../UserDropdown';
import { formatRoundDates } from '../../utils/matchHelpers';

/**
 * RoundHeader component for round navigation and controls
 */
const RoundHeader = ({
  currentRound,
  roundInfo,
  maxRound,
  matches,
  points,
  adminMode,
  isAdmin,
  allUsers,
  selectedUserId,
  currentUserId,
  onPreviousRound,
  onNextRound,
  onToggleAdminMode,
  onUserSelect,
}) => {
  const hasCompletedMatches = matches.some((m) => m.status === 'completed');

  return (
    <div className={`compact-header ${isAdmin ? 'admin-header' : ''}`}>
      {/* Left: Previous Arrow + Points */}
      <div className="header-left">
        <button
          onClick={onPreviousRound}
          disabled={currentRound === 1}
          className="nav-arrow"
          title="Previous Round"
        >
          ←
        </button>
        {hasCompletedMatches && !adminMode && (
          <span className="points-compact">{points} pts</span>
        )}
      </div>

      {/* Center: Round + Mode + Season Info */}
      <div className="header-center">
        <div className="round-title-container">
          <span className="round-text">Round {currentRound}</span>
          {roundInfo && roundInfo.startDate && (
            <span className="round-dates">{formatRoundDates(roundInfo)}</span>
          )}
        </div>
      </div>

      {/* Right: User Selector + Admin Toggle + Next Arrow */}
      <div className="header-right">
        {isAdmin && allUsers.length > 0 && (
          <UserDropdown
            users={allUsers}
            selectedUserId={selectedUserId || currentUserId}
            currentUserId={currentUserId}
            onSelect={onUserSelect}
          />
        )}
        {isAdmin && (
          <button
            onClick={onToggleAdminMode}
            className="toggle-icon"
            title={adminMode ? 'Switch to Picks Mode' : 'Switch to Score Entry Mode'}
          >
            {adminMode ? '👤' : '⚙️'}
          </button>
        )}
        {matches.length > 0 && (
          <button
            onClick={onNextRound}
            disabled={maxRound !== null && currentRound >= maxRound}
            className="nav-arrow"
            title="Next Round"
          >
            →
          </button>
        )}
      </div>
    </div>
  );
};

export default RoundHeader;
